import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const isChunkLoadError = (error) => {
  if (!error) return false;
  if (error.name === 'ChunkLoadError') return true;
  const msg = String(error.message || error);
  return /Loading chunk \d+ failed/i.test(msg) || /Failed to fetch dynamically imported module/i.test(msg);
};

// Eski deploy chunkalari topilmaganda — bir martalik qayta yuklash bilan toza index.html olamiz
const reloadOnce = () => {
  const KEY = 'chunk_reload_attempted_at';
  const lastTry = Number(sessionStorage.getItem(KEY) || 0);
  const now = Date.now();
  // 30 soniyada bir martadan ko'p reload qilmaslik (loop'dan qochish)
  if (now - lastTry < 30000) return false;
  sessionStorage.setItem(KEY, String(now));
  window.location.reload();
  return true;
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, isChunkError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, isChunkError: isChunkLoadError(error) };
  }

  componentDidCatch(error, errorInfo) {
    if (isChunkLoadError(error)) {
      if (reloadOnce()) return;
    }
    if (process.env.NODE_ENV !== 'production') {
      console.error('ErrorBoundary caught:', error, errorInfo);
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, isChunkError: false });
    window.location.href = '/dashboard/app';
  };

  render() {
    if (this.state.hasError) {
      // Chunk load xato bo'lsa va reload tetiklangan bo'lsa — bo'sh ekran (qayta yuklanyapti)
      if (this.state.isChunkError) {
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '100vh',
            }}
          >
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Yangilanmoqda...
            </Typography>
          </Box>
        );
      }

      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            gap: 2,
            p: 3,
            textAlign: 'center',
          }}
        >
          <Typography variant="h4">Xatolik yuz berdi</Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 480 }}>
            Kutilmagan xatolik yuz berdi. Iltimos, sahifani qayta yuklang yoki bosh sahifaga qayting.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
            <Button variant="outlined" onClick={() => window.location.reload()}>
              Qayta yuklash
            </Button>
            <Button variant="contained" onClick={this.handleReset}>
              Bosh sahifaga qaytish
            </Button>
          </Box>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
